<template>
  <el-form
    v-on="$listeners"
    v-bind="{
      'size': $store.state.formSize,
      ...$attrs
    }"
  >
    <slot></slot>
  </el-form>
</template>

<script>
export default {
  name: 'CustomForm',
  inheritAttrs: true
}
</script>
